<div class="UP-Wrapper">
  <div class="UP-Header">
    <h2 class="UP-Header-Title">
      {{userShop}}
    </h2>
    <div class="UP-Header-Details">
      <one-icon name="checkmark-circle-outline"></one-icon>
      <h6>You’ve paid for your order.</h6>
      <a href="#">View order confirmation ›</a>
    </div>
  </div>
  <div class="UP-Body">
    <div class="UP-Body-Banner">
      <h4 class="UP-Body-Banner-Title">{{ data?.banner_title }}</h4>
      <div class="UP-Body-Banner-Timer" *ngIf="data?.timer_enabled">
        {{data?.timer_text}}
        <strong>{{ formattedTime }}</strong>
      </div>
    </div>
    <div class="UP-Body-Product">
      <div class="UP-Body-Product-Image" *ngIf="imageView === 'default'">
        <img class="_image" alt=""
             [src]="images?.[0]?.url || data?.selectedVariant?.product_image_url || '/app_assets/upload_image_placeholder.svg'">
      </div>
      <div class="UP-Body-Product-Image" *ngIf="imageView === 'arrows'">
        <div class="UP-Body-Product-Image-Arrows" [style.backgroundImage]="'url(' + images[imageIndex]?.url || data?.selectedVariant?.product_image_url || '/app_assets/upload_image_placeholder.svg' + ')'">
          <img (click)="shiftImageindex(-1)" class="_arrow _left"
              src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjIwMCIKICAgaGVpZ2h0PSIzMCIKICAgdmlld0JveD0iMCAwIDUxMiA1MTIiCiAgIHZlcnNpb249IjEuMSIKICAgaWQ9InN2ZzExIgogICBzb2RpcG9kaTpkb2NuYW1lPSJsZWZ0LnN2ZyIKICAgaW5rc2NhcGU6dmVyc2lvbj0iMS4yIChkYzJhZWRhLCAyMDIyLTA1LTE1KSIKICAgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiCiAgIHhtbG5zOnNvZGlwb2RpPSJodHRwOi8vc29kaXBvZGkuc291cmNlZm9yZ2UubmV0L0RURC9zb2RpcG9kaS0wLmR0ZCIKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZGVmcwogICAgIGlkPSJkZWZzMTUiIC8+CiAgPHNvZGlwb2RpOm5hbWVkdmlldwogICAgIGlkPSJuYW1lZHZpZXcxMyIKICAgICBwYWdlY29sb3I9IiNmZmZmZmYiCiAgICAgYm9yZGVyY29sb3I9IiMwMDAwMDAiCiAgICAgYm9yZGVyb3BhY2l0eT0iMC4yNSIKICAgICBpbmtzY2FwZTpzaG93cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTpwYWdlb3BhY2l0eT0iMC4wIgogICAgIGlua3NjYXBlOnBhZ2VjaGVja2VyYm9hcmQ9IjAiCiAgICAgaW5rc2NhcGU6ZGVza2NvbG9yPSIjZDFkMWQxIgogICAgIHNob3dncmlkPSJmYWxzZSIKICAgICBpbmtzY2FwZTp6b29tPSI2LjIzIgogICAgIGlua3NjYXBlOmN4PSIzMi41MDQwMTMiCiAgICAgaW5rc2NhcGU6Y3k9IjE1LjE2ODUzOSIKICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjEzOTAiCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iOTY3IgogICAgIGlua3NjYXBlOndpbmRvdy14PSIzNDAiCiAgICAgaW5rc2NhcGU6d2luZG93LXk9IjI1IgogICAgIGlua3NjYXBlOndpbmRvdy1tYXhpbWl6ZWQ9IjAiCiAgICAgaW5rc2NhcGU6Y3VycmVudC1sYXllcj0ic3ZnMTEiIC8+CiAgPGVsbGlwc2UKICAgICBzdHlsZT0ib3BhY2l0eTowLjE1O2ZpbGw6I2ZmZmZmZjtzdHJva2Utd2lkdGg6MjAuOTY3NyIKICAgICBpZD0icGF0aDIyNyIKICAgICByeT0iMjUzLjM5NzU3IgogICAgIHJ4PSIyNTQuNzY3MjYiCiAgICAgY3k9IjI1Ny41MDY2OCIKICAgICBjeD0iLTExOTEuNzkwMyIgLz4KICA8cGF0aAogICAgIGQ9Im0gLTEyNDguMTM0OSwyNTYgMTI3LjA5OTksLTEyNyBjIDkuNCwtOS40IDkuNCwtMjQuNiAwLC0zMy45IC05LjQsLTkuNCAtMjQuNiwtOS4zIC0zNCwwIEwgLTEyOTkuMDM0OSwyMzkgYyAtOS4xLDkuMSAtOS4zLDIzLjcgLTAuNywzMy4xIEwgLTExNTUuMTM1LDQxNyBjIDQuNyw0LjcgMTAuOSw3IDE3LDcgNi4xLDAgMTIuMywtMi4zIDE3LC03IDkuNCwtOS40IDkuNCwtMjQuNiAwLC0zMy45IHoiCiAgICAgaWQ9InBhdGg5IgogICAgIHN0eWxlPSJvcGFjaXR5OjAuOCIgLz4KPC9zdmc+Cg==" alt="">
          <div></div>
          <img (click)="shiftImageindex(1)" class="_arrow _right"
            src="data:image/svg+xml;base64,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" alt="">
        </div>
      </div>
      <div class="UP-Body-Product-Image" *ngIf="imageView === 'carousel'">
        <div class="UP-Body-Product-Image-Carousel">
          <div class="_image" alt=""
               [style.backgroundImage]="'url(' + (images[imageIndex]?.url || '/app_assets/upload_image_placeholder.svg') + ')'">
          </div>
          <div class="_carousel">
            <img (click)="shiftImageindex(-1)" class="_arrow"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDUxMiA1MTIiPjxwYXRoIGQ9Ik0yMTcuOSAyNTZMMzQ1IDEyOWM5LjQtOS40IDkuNC0yNC42IDAtMzMuOS05LjQtOS40LTI0LjYtOS4zLTM0IDBMMTY3IDIzOWMtOS4xIDkuMS05LjMgMjMuNy0uNyAzMy4xTDMxMC45IDQxN2M0LjcgNC43IDEwLjkgNyAxNyA3czEyLjMtMi4zIDE3LTdjOS40LTkuNCA5LjQtMjQuNiAwLTMzLjlMMjE3LjkgMjU2eiIvPjwvc3ZnPg==" alt="">
            <ng-container *ngFor="let image of images; let index = index">
              <div class="_thumbnail" [class._disabled]="index === imageIndex" (click)="imageIndex = index"
                   [style.backgroundImage]="'url(' + (images[index]?.url || '/app_assets/upload_image_placeholder.svg') + ')'"
                   [style.height]="400 / (images.length + 1) + 'px'">
              </div>
            </ng-container>
            <img (click)="shiftImageindex(1)" class="_arrow"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDUxMiA1MTIiPjxwYXRoIGQ9Ik0yOTQuMSAyNTZMMTY3IDEyOWMtOS40LTkuNC05LjQtMjQuNiAwLTMzLjlzMjQuNi05LjMgMzQgMEwzNDUgMjM5YzkuMSA5LjEgOS4zIDIzLjcuNyAzMy4xTDIwMS4xIDQxN2MtNC43IDQuNy0xMC45IDctMTcgN3MtMTIuMy0yLjMtMTctN2MtOS40LTkuNC05LjQtMjQuNiAwLTMzLjlsMTI3LTEyNy4xeiIvPjwvc3ZnPg==" alt="">
          </div>
        </div>
      </div>

      <div class="UP-Body-Product-Aside">
        <div class="UP-Body-Product-Details">
          <div class="UP-Body-Product-Details-Title">
            {{ data?.product_title || 'Sample Product' }}
          </div>
          <div class="UP-Body-Product-Details-Price">
            <span class="UP-Body-Product-Details-Price-NoDiscount" *ngIf="!data?.discounted; else showDiscount" [class._muted]="data?.soldOut">
              {{ originalPrice | currency:data?.currency }}
            </span>
            <ng-template #showDiscount>
              <span class="UP-Body-Product-Details-Price-Old" [class._muted]="data?.soldOut">
                {{ originalPrice | currency:data?.currency:'symbol' }}
              </span>
              <span class="UP-Body-Product-Details-Price-New" [class._muted]="data?.soldOut">
                {{ formatPrice(discountedPrice) }}
              </span>
              <span class="UP-Body-Product-Details-Price-Label" *ngIf="data?.label" [class._muted]="data?.soldOut">
                ({{ discountLabel }})
              </span>
            </ng-template>
          </div>
          <div class="UP-Body-Product-Details-Description">
            <div class="" *ngIf="isCustomDescription; else defaultDescription" [innerHTML]="customDescriptionHtml"></div>
            <ng-template #defaultDescription>
              {{ productDescription }}
            </ng-template>
            <a *ngIf="showReadMore || showCustomReadmore" class="_local-read-more" (click)="readMore = !readMore">{{ (readMore ? 'less' : 'see more') | translateUpsell:(data.locale || 'en') }}</a>
          </div>
          <div class="UP-Body-Product-Details-Controls" [class._single]="!data?.options?.length">
            <div class="UP-Body-Product-Details-Control">
              <ng-container *ngIf="data?.predefined_quantity || data?.soldOut; else quantityInput">
                <div class="UP-Body-Product-Details-Control-Select _disabled">
                  <small>{{ 'Quantity'  | translateUpsell:(data.locale || 'en') }}</small>
                  <mat-form-field class="pf-form-field w-100">
                    <mat-select class="form-control _upsell-preview disabled" disabled
                    [(ngModel)]="data.quantity"
                    (selectionChange)="variantChange()">
                    <mat-option class="pt-2" [value]="data.quantity">
                      {{ data.quantity }}
                    </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #quantityInput>
                <div class="UP-Body-Product-Details-Control-Input">
                  <small>{{ 'Quantity'  | translateUpsell:(data.locale || 'en') }}</small>
                  <input type="number" class="form-control"
                        [(ngModel)]="localQuantity"
                        (click)="onNumberInputClick($event)"
                        (focusout)="qunatityChange()">
                </div>
              </ng-template>
            </div>
            <div *ngFor="let option of data.options" class="UP-Body-Product-Details-Control">
              <div class="UP-Body-Product-Details-Control-Select">
                <small>{{ option.name  | translateUpsell:(data.locale || 'en') }}</small>
                <mat-form-field class="pf-form-field w-100">
                  <mat-select class="form-control _upsell-preview"
                  [disabled]="option.disabled" [class.disabled]="option.disabled"
                  [(ngModel)]="option.selected"
                  (selectionChange)="variantChange()">
                  <mat-option *ngFor="let value of option.values" class="pt-2" [value]="value.value">
                    <span class="pt-2">{{ value.label }}</span>
                  </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="UP-Body-Product-Details-Breakdown">
            <div class="UP-Body-Product-Details-Breakdown-Item">
              <span>{{ 'Subtotal'  | translateUpsell:(data.locale || 'en') }}</span>
              <strong>{{ formatPrice(discountedPrice) }}</strong>
            </div>
            <div class="UP-Body-Product-Details-Breakdown-Item">
              <span>{{ 'Shipping'  | translateUpsell:(data.locale || 'en') }}</span>
              <strong>{{ formatPrice(shippingPrice) }}</strong>
            </div>
            <div class="UP-Body-Product-Details-Breakdown-Item">
              <span>{{ 'Taxes'  | translateUpsell:(data.locale || 'en') }}</span>
              <strong class="_tooltip"
                matTooltipClass="Tooltip-Box"
                matTooltipPosition="above"
                matTooltip="Taxes will be calculated for the real upsell offer.">
                {{ 'N/A' | translateUpsell:(data.locale || 'en') }}
              </strong>
            </div>
            <div class="UP-Body-Product-Details-Breakdown-Total">
              <span>{{ 'Total'  | translateUpsell:(data.locale || 'en') }}</span>
              <span>{{ formatPrice(finalPrice) }}</span>
            </div>
          </div>
          <div class="UP-Body-Product-Details-Buttons">
            <button class="pf-button filled blue" [class._disabled]="data?.soldOut">
              {{ acceptButtonText | translateUpsell:(data.locale || 'en') }}
            </button>
            <small class="text-center text-muted">{{ 'You will be charged immediately' | translateUpsell:(data.locale || 'en') }}</small>
            <button class="pf-button outline gray">
              {{ data?.decline_button_text | translateUpsell:(data.locale || 'en') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="UP-Footer">
    <p class="UP-Footer-Copyright">
      All rights reserved {{ userShop }}
    </p>
  </div>
</div>
